"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stageDeadlineTooltip = exports.stageTriggerTooltip = exports.decisionRuleTooltips = exports.createReviewStagesCurrentUser = exports.REVIEW_TYPE = exports.INITIAL_MEMBER = exports.INITIAL_ROUND = exports.INITIAL_OWNER = exports.newStageDefault = void 0;
const uuid_1 = require("uuid");
const helper_1 = require("../../../../reviews/helper");
const mockData_1 = require("./ReviewStage/StageSettings/mockData");
const newStageDefault = (stageNumber = 1) => ({
    isOpen: true,
    nameStage: `Stage ${stageNumber}`,
    members: [],
    deadlineType: mockData_1.DEADLINE[0].value,
    deadline: null,
    progress: {
        notified: false,
        opened: false,
        commented: false,
        completed: false,
    },
    status: 'not_started',
    statusLabel: 'Not started',
    commentCount: 0,
    triggerTypeId: 1,
    triggerParentStageId: null,
    triggerParentStageName: null,
    clientId: '',
});
exports.newStageDefault = newStageDefault;
exports.INITIAL_OWNER = {
    ownerId: parseInt(helper_1.USER.id),
    ownerName: helper_1.USER === null || helper_1.USER === void 0 ? void 0 : helper_1.USER.name,
};
exports.INITIAL_ROUND = {
    reviewId: 12,
    ...exports.INITIAL_OWNER,
    roundId: 33,
    roundName: 1,
    roundTypeId: 6,
    roundType: 'internal',
    roundTypeLabel: 'Internal',
};
exports.INITIAL_MEMBER = {
    isWrench: true,
    progress: {
        notified: false,
        opened: false,
        commented: false,
        completed: false,
    },
    view: true,
    share: false,
    comment: true,
    decision: false,
    manage: false,
};
exports.REVIEW_TYPE = [
    {
        value: 'internal',
        label: 'Internal',
    },
    {
        value: 'external',
        label: 'External',
    },
];
const createReviewStagesCurrentUser = () => {
    const clientId = (0, uuid_1.v4)();
    return [
        {
            isOpen: true,
            nameStage: 'Stage 1',
            clientId,
            parentStageId: undefined,
            members: [
                {
                    id: parseInt(helper_1.USER.id),
                    name: helper_1.USER.name,
                    email: helper_1.USER.email,
                    clientName: helper_1.USER.clientname,
                    category: helper_1.USER.category,
                    role: helper_1.USER.role,
                    isWrench: true,
                    progress: {
                        notified: false,
                        opened: false,
                        commented: false,
                        completed: false,
                    },
                    view: true,
                    share: false,
                    comment: true,
                    decision: false,
                    manage: true,
                    avatarUrl: helper_1.USER.avatarUrl,
                },
            ],
            ...exports.INITIAL_OWNER,
            deadlineType: mockData_1.DEADLINE[0].value,
            deadline: null,
            progress: {
                notified: false,
                opened: false,
                commented: false,
                completed: false,
            },
            status: 'not_started',
            statusLabel: 'Not started',
            commentCount: 0,
            isDefaultStage: true,
            triggerTypeId: 1,
            triggerParentStageId: null,
            triggerParentStageName: null,
        },
    ];
};
exports.createReviewStagesCurrentUser = createReviewStagesCurrentUser;
exports.decisionRuleTooltips = 'Controls how reviewer decisions are evaluated to complete the stage. \nChoose One User to complete the stage after any assigned reviewer submits a decision. \nChoose All Users to require all assigned reviewers to submit decisions. \nChoose Custom to define a specific combination of required decisions.';
exports.stageTriggerTooltip = 'Controls how the stage starts. \nChoose Immediately to start the stage as soon as it becomes available in the workflow sequence.\nChoose When to start it automatically after selected prior stages are completed and the specified decision outcomes are met.\nChoose Manually to require a user to start the stage.\nDeadlines do not start stages.';
exports.stageDeadlineTooltip = 'Sets when this stage is due. \nDeadlines are visual only and do not affect workflow progression, stage triggers, or completion rules. \nThe stage displays orange three days before the deadline and red once the deadline has passed.';
